import { useLocalStorage } from 'shared/hooks/useLocalStorage'
import { EntityType, RecentlyVisitedItem } from '../types'

const STORAGE_KEY = 'globalSearch:recentlyVisited'
const MAX_RECENTLY_VISITED = 15

export function useRecentlyVisited() {
    const [recentlyVisited, setRecentlyVisited] = useLocalStorage<
        RecentlyVisitedItem[]
    >(STORAGE_KEY, [])

    const addVisit = (
        type: EntityType,
        id: string,
        name: string,
        subtitle?: string,
        path?: string
    ) => {
        setRecentlyVisited((prev) => {
            const filtered = prev.filter(
                (item) => !(item.type === type && item.id === id)
            )

            const defaultPath = (() => {
                switch (type) {
                    case 'candidate':
                        return `/people/${id}/overview/on`
                    case 'roster':
                        return `/searches/${id}/candidates/on`
                    case 'company':
                        return `/companies/${id}`
                }
            })()

            const newItem: RecentlyVisitedItem = {
                type,
                id,
                name,
                subtitle,
                path: path ?? defaultPath,
                timestamp: Date.now(),
            }

            return [newItem, ...filtered].slice(0, MAX_RECENTLY_VISITED)
        })
    }

    const removeVisit = (type: EntityType, id: string) => {
        setRecentlyVisited((prev) =>
            prev.filter((item) => !(item.type === type && item.id === id))
        )
    }

    const clearAll = () => {
        setRecentlyVisited([])
    }

    return {
        recentlyVisited,
        addVisit,
        removeVisit,
        clearAll,
    }
}
